module.exports = __webpack_public_path__ + "img/img1.0c396f53.svg";